var areaConversionUtil = {};
var areaSingleConversionUtil = {};
var areaSimplifyConversionUtil = {};//省份简化，如湖北省->湖北


areaConversionUtil.codeToName = function(data){
  var array = data;

  var place = window.place.province;

  for(var i=0;i<array.length;i++){
    var element = array[i];

    // 省市 code => name 处理
    if(element.provinceCode){
      var element2 = place.find(item=>item.id===element.provinceCode);

      // //黑龙江 ，内蒙古
      // if(element.name == '黑龙江省'){
      //   element.provinceName = '黑龙江';
      // }else if(element.name == '内蒙古自治区'){
      //   element.provinceName = '内蒙古';
      // }else{
      //   element.provinceName = element2.name.substr(0,2);
      // }
      element.provinceName = element2.name;

      if(element.cityCode){
        var cityCode = element.cityCode.substr(2,2);
        var element3 = element2.children.find(item=>item.id===cityCode);
        element.cityName = element3.name;
      }
    }else{
      element.provinceName = '--'
      element.cityName = '--'
      element.hospitalName = '--'
    }

    // 当前状态
    if(element.status){
      if(element.status == 1){
        element.statusText="正常"
      } else if(element.status == 2){
        element.statusText="关机"
      }else if(element.status == 3){
        element.statusText="故障"
      }else if(element.status == 4){
        element.statusText="手术中"
      }
    }


    //故障处理状态
    //处理状态
    if(element.maintainStatus){
      if(element.maintainStatus==1){
        element.maintainStatusText = '未处理';
      }else if(element.maintainStatus==2){
        element.maintainStatusText = '处理中';
      }else if(element.maintainStatus==3){
        element.maintainStatusText = '处理完成';
      }
    }

  }
}

areaSimplifyConversionUtil.codeToName = function(data){
  var array = data;

  var place = window.place.province;

  for(var i=0;i<array.length;i++){
    var element = array[i];

    // 省市 code => name 处理
    if(element.provinceCode){
      var element2 = place.find(item=>item.id===element.provinceCode);

      //黑龙江 ，内蒙古
      if(element.name == '黑龙江省'){
        element.provinceName = '黑龙江';
      }else if(element.name == '内蒙古自治区'){
        element.provinceName = '内蒙古';
      }else{
        element.provinceName = element2.name.substr(0,2);
      }


      if(element.cityCode){
        var cityCode = element.cityCode.substr(2,2);
        var element3 = element2.children.find(item=>item.id===cityCode);
        element.cityName = element3.name;
      }
    }else{
      element.provinceName = '--'
      element.cityName = '--'
      element.hospitalName = '--'
    }

    // 当前状态
    if(element.status){
      if(element.status == 1){
        element.statusText="正常"
      } else if(element.status == 2){
        element.statusText="关机"
      }else if(element.status == 3){
        element.statusText="故障"
      }else if(element.status == 4){
        element.statusText="手术中"
      }
    }


    //故障处理状态
    //处理状态
    if(element.maintainStatus){
      if(element.maintainStatus==1){
        element.maintainStatusText = '未处理';
      }else if(element.maintainStatus==2){
        element.maintainStatusText = '处理中';
      }else if(element.maintainStatus==3){
        element.maintainStatusText = '处理完成';
      }
    }

  }
}



areaSingleConversionUtil.codeToName = function(element){

  var place = window.place.province;

    // 省市 code => name 处理
    if(element.provinceCode){
      var element2 = place.find(item=>item.id===element.provinceCode);
      // element.provinceName = element2.name;
      //黑龙江 ，内蒙古
      if(element.name == '黑龙江省'){
        element.provinceName = '黑龙江';
      }else if(element.name == '内蒙古自治区'){
        element.provinceName = '内蒙古';
      }else{
        element.provinceName = element2.name.substr(0,2);
      }

      if(element.cityCode){
        var cityCode = element.cityCode.substr(2,2);
        var element3 = element2.children.find(item=>item.id===cityCode);
        element.cityName = element3.name;
      }
    }
}

export { areaConversionUtil , areaSingleConversionUtil , areaSimplifyConversionUtil}



// WEBPACK FOOTER //
// ./src/utils/povince_handle.js